import React, { createContext, useContext, useState } from "react";

const InvoiceContext = createContext();

export const InvoiceProvider = ({ children }) => {
  const [invoiceState, setInvoiceState] = useState({
    currentInvoice: null,
    currentCustomer: null,
    currentPricelistName: null,
    aggregateParts: false,
    allParts: [],
    showFullPartNumbers: true,
  });

  const setCurrentInvoice = (invoice) => {
    setInvoiceState((prev) => ({ ...prev, currentInvoice: invoice }));
  };

  const setCurrentCustomer = (customer) => {
    setInvoiceState((prev) => ({ ...prev, currentCustomer: customer }));
  };

  const setCurrentPricelistName = (name) => {
    setInvoiceState((prev) => ({ ...prev, currentPricelistName: name }));
  };

  const setAggregateParts = (aggregate) => {
    setInvoiceState((prev) => ({ ...prev, aggregateParts: aggregate }));
  };

  const setAllParts = (parts) => {
    setInvoiceState((prev) => ({ ...prev, allParts: parts }));
  };

  const setShowFullPartNumbers = (show) => {
    setInvoiceState((prev) => ({ ...prev, showFullPartNumbers: show }));
  };

  const resetState = () => {
    setInvoiceState({
      currentInvoice: null,
      currentCustomer: null,
      currentPricelistName: null,
      aggregateParts: false,
      allParts: [],
      showFullPartNumbers: true,
    });
  };

  return (
    <InvoiceContext.Provider
      value={{
        ...invoiceState,
        setCurrentInvoice,
        setCurrentCustomer,
        setCurrentPricelistName,
        setAggregateParts,
        setAllParts,
        setShowFullPartNumbers,
        resetState,
      }}
    >
      {children}
    </InvoiceContext.Provider>
  );
};

export const useInvoice = () => {
  const context = useContext(InvoiceContext);
  if (!context) {
    throw new Error("useInvoice must be used within an InvoiceProvider");
  }
  return context;
};
